/**
 * A polygon-clipping operation, retried on coarser grids when the clipper
 * refuses its input.
 *
 * `polygon-clipping` throws ("Unable to complete output ring") on edges that
 * nearly coincide: a wall's strip ending a hair off a ceiling facet's edge, a
 * wall footprint a hair off a room's outline. Snapped onto a grid the near
 * edge coincides exactly, which the clipper does handle. 10 µm first, then
 * 0.1 mm, then 1 mm — far below anything a scan measures.
 *
 * Pure.
 */

const SNAP_GRIDS = [1e5, 1e4, 1e3];

/**
 * Run `run(snap)` — `snap` rounds one coordinate onto the grid being tried —
 * until it does not throw.
 *
 * @param {(snap: (v: number) => number) => *} run
 * @param {{ exactFirst?: boolean }} [opts] try the unsnapped input first
 * @returns {{ value: *, grid: number|null } | null} what `run` returned and the
 *   grid it took (null for the exact input), or null when every grid failed
 */
function withSnapRetry(run, { exactFirst = false } = {}) {
  const grids = exactFirst ? [null, ...SNAP_GRIDS] : SNAP_GRIDS;
  for (const grid of grids) {
    const snap = grid ? (v) => Math.round(v * grid) / grid : (v) => v;
    try {
      return { value: run(snap), grid };
    } catch {
      // the next, coarser grid
    }
  }
  return null;
}

module.exports = { SNAP_GRIDS, withSnapRetry };
